import { Grid, Stack, Typography, TypographyProps } from "@mui/material";
import { numberFormatAsString } from "commons/ultilities";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { observer } from "mobx-react-lite";
import { IWorkOrderProperties } from "mobx-stores/_models/work-order/work-order";
import { IWorkOrderItemProperties } from "mobx-stores/_models/work-order/work-order-item";
import { useStores } from "mobx-stores/_root-store";
import { ReactNode, useCallback, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { PrintPreviewDialog } from "share-components/templates/print/print-preview-dialog";

export const PackagePrintPreview = observer(() => {
  const {
    workOrderManagement: { openPackagePrint, setProp, workOrderDetail },
  } = useStores();
  const contentRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    contentRef,
  });
  const onPrintClicked = useCallback(() => {
    handlePrint();
  }, [handlePrint]);
  const onCloseHandler = useCallback(() => {
    setProp("openPackagePrint", false);
  }, [setProp]);
  return (
    <PrintPreviewDialog
      open={openPackagePrint}
      fullWidth
      maxWidth="md"
      onClose={onCloseHandler}
      onPrintClicked={onPrintClicked}
    >
      <style>
        {`@media print {
              @page {
                size: A4 portrait;
              }
          }`}
      </style>
      <Grid
        ref={contentRef}
        container
        sx={{ width: "21cm", padding: "10px" }}
        spacing={1}
      >
        {workOrderDetail?.items &&
          workOrderDetail?.items.map((x, idx) => {
            const breakPage = idx !== 0 && idx % 10 === 0;
            return (
              <Grid
                key={x.id}
                item
                xs={6}
                sx={{ breakBefore: breakPage ? "page" : undefined }}
              >
                <PackageItemPrint
                  item={x}
                  workOrder={workOrderDetail}
                ></PackageItemPrint>
              </Grid>
            );
          })}
      </Grid>
    </PrintPreviewDialog>
  );
});
type PackageItemPrintProps = {
  workOrder: IWorkOrderProperties;
  item: IWorkOrderItemProperties;
};
const PackageItemPrint = ({ item, workOrder }: PackageItemPrintProps) => {
  const fontWeight = "800";
  return (
    <Grid
      container
      sx={{
        border: `1px solid`,
        height: "5.6cm",
        padding: "3px",
        lineHeight: "0.5",
      }}
    >
      <Grid item xs={6}>
        <Stack>
          <TypoOfItem>BAO BÌ Á CHÂU</TypoOfItem>
          <TypoOfItem>1524 TL8, x.Hòa Phú, H.Củ Chi</TypoOfItem>
          <TypoOfItem>www.baobiachau.vn</TypoOfItem>
        </Stack>
      </Grid>
      <Grid item xs={6}>
        <Stack direction={"column"} justifyContent={"center"} height={"100%"}>
          <Typography fontWeight={fontWeight} fontSize={"15px"}>
            {`Phiếu đóng gói`.toUpperCase()}
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs={12} component={"span"}>
        <TypoOfItem fontWeight={fontWeight} textOverflow={"clip"}>
          {item.product?.customer?.name || ""}
        </TypoOfItem>
      </Grid>
      <Grid item xs={12}>
        <ItemInfo title="Tên hàng" value={item.product?.name || ""}></ItemInfo>
      </Grid>
      <Grid item xs={6}>
        <ItemInfo title="Mã hàng" value={item.product?.code || ""}></ItemInfo>
      </Grid>
      <Grid item xs={6}>
        <ItemInfo title="STT Kiện" value=""></ItemInfo>
      </Grid>
      <Grid item xs={6}>
        <ItemInfo
          title="Đơn ĐH"
          value={workOrder.purchaseOrder?.poNumber || ""}
        ></ItemInfo>
      </Grid>
      <Grid item xs={6}>
        <ItemInfo
          title="Ngày ĐH"
          value={dateTimeDisplay(workOrder.purchaseOrder?.poDate || "")}
        ></ItemInfo>
      </Grid>
      <Grid item xs={6}>
        <ItemInfo title="Số LSX" value={workOrder.woNumber || ""}></ItemInfo>
      </Grid>
      <Grid item xs={6}>
        <ItemInfo
          title="Ngày LSX"
          value={dateTimeDisplay(workOrder.date || "")}
        ></ItemInfo>
      </Grid>
      <Grid item xs={6}>
        <ItemInfo
          title="Ngày đóng gói"
          value={dateTimeDisplay(item.packageDate || "")}
        ></ItemInfo>
      </Grid>
      <Grid item xs={6}>
        <ItemInfo
          title="Số lượng"
          value={numberFormatAsString(item.amount?.toString() || "")}
        ></ItemInfo>
      </Grid>
      <Grid item xs={6}>
        <ItemInfo title="Số hộp (toa)/Bản in" value=""></ItemInfo>
      </Grid>
      <Grid item xs={6}>
        <ItemInfo
          title="TL Tỉnh (kg)"
          value={`${numberFormatAsString(
            item.product?.dimensionWeight?.weightStandard?.toString() || ""
          )}`}
        ></ItemInfo>
      </Grid>
      {/* <Grid item xs={6}>
        <ItemInfo
          title="Người ĐG"
          value={workOrder.kcsPackage || ""}
        ></ItemInfo>
      </Grid>
      <Grid item xs={6}>
        <ItemInfo title="TL có bì (kg)" value={``}></ItemInfo>
      </Grid>
      <Grid item xs={6}>
        <ItemInfo title="KCS Kiểm" value={workOrder.kcsTest || ""}></ItemInfo>
      </Grid> */}
      <Grid item xs={6}>
        <ItemInfo
          title="HSD"
          value={
            dateTimeDisplay(item.product?.approval?.businessExpiredDate) || ""
          }
        ></ItemInfo>
      </Grid>
    </Grid>
  );
};
type ItemInfoProps = {
  title: ReactNode;
  value: ReactNode;
};
const ItemInfo = ({ title, value }: ItemInfoProps) => {
  return (
    <TypoOfItem component={"span"}>
      {`${title}: `}
      <TypoOfItem component={"span"} sx={{ fontWeight: "800" }}>
        {value}
      </TypoOfItem>
    </TypoOfItem>
  );
};

const TypoOfItem = (props: TypographyProps) => {
  return (
    <Typography {...props} fontSize={"11px"}>
      {props.children}
    </Typography>
  );
};
